module.exports = "<div class=\"input checkbox listed searchable\">\r\n    <label for=\"multi_<%= property.id %>\"><%= property.get('description') %></label>\r\n    <div id=\"multi_<%= property.id %>\" style=\"width: 500px;float:left\" name=\"<%= property.id %>\" class=\"validate[minCheckbox[1]] multi_<%= property.id %>\" data-prompt-position=\"topRight\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/templates/edit_report_saved_view/multiselect_cols_view.template
// module id = 540
// module chunks = 51